export default function isHIITArea(area: string) {
  return area === 'FES_HIIT_ZONE';
}
